import * as React from "react";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";

import Content from "./Content";
import { UploadedFileResponse, UploadOptions } from "./AbstractDropzone";

interface DropzoneProps {
  containerClass: string;
  dropzoneClass: string;
  upload: UploadOptions;
  children: React.ReactChild | React.ReactChild[];
  error?: React.ReactChild;
  assignRef: (e: any) => void;
  onUploadBtnClick: () => void;
  onFinish: (res: UploadedFileResponse) => void;
}

const DropzoneLayout = ({
  assignRef,
  onUploadBtnClick,
  dropzoneClass,
  containerClass,
  ...props,
}: DropzoneProps) => (
  <div className={containerClass}>
    <DropzoneS3Uploader
      className={dropzoneClass}
      style={{}}
      s3Url="DOES_NOT_MATTER_SINCE_WE_USE_SERVER_URL"
      ref={assignRef}
      {...props}
    >
      <Content>{props.children}</Content>
    </DropzoneS3Uploader>
    {props.error}
    <button
      type="button"
      className="dropzone__upload-btn"
      onClick={onUploadBtnClick}
    >
      Chọn tệp
    </button>
  </div>
);

export default DropzoneLayout;



// WEBPACK FOOTER //
// ./src/components/Dropzone/Layout.tsx